<div class="mapeditor-outer">
  <app-loader [Parent]="Busyable"></app-loader>
  <google-map #map class="mapeditor-inner" [options]="MapOptions" height="100%" width="100%" [zoom]="15">
    @for (m of PingSensors; track m) {
      <map-marker [position]="{ lat: m.GeoLocationPoints.lat, lng: m.GeoLocationPoints.lng }"
        [icon]="getMarkerIcon(m.IsOccupied)"
        [options]="{ draggable: true, zIndex: 100 }">
      </map-marker>
    }
  </google-map>
  <div class="lotlevelselect">
    @if (ShowLotSelect) {
      <div class="select">
        <select class="input" (change)="SelectLot($event)" aria-placeholder="Select a Lot">
          <option value="All">All Lots</option>
          @for (i of ParkingLots; track i) {
            <option [value]="i.Id" [disabled]="LotForStructure(i)">{{i.Name}}</option>
          }
        </select>
      </div>
    }
    @if (ShowLevelSelect && this.ParkingLevels != null && this.ParkingLotId != null) {
      <div class="select">
        <select class="input" (change)="SelectLevel($event)" aria-placeholder="Select a Level">
          <option value="All">All {{(LotsOrZones())}}</option>
          @for (i of ParkingLevels; track i) {
            <option [value]="i.Id">{{i.Name}}</option>
          }
        </select>
      </div>
    }
  </div>
  <div class="menu">
    <div class="title"><i class="fa fa-chevron-left"></i></div>
    <article class="panel is-success nav">
      @for (i of AvailableLayers; track i) {
        <a class="panel-block">
          <input type="checkbox" [checked]="IsItemInLayers(i.Type, i.SubItemTypes)" (change)="ToggleLayer($event, i.Type, i.SubItemTypes)">
          {{ (i.Type == 'ParkingLevel' ? (ParkingLotId != null ? 'Parking' + LotsOrZones() : i.DisplayName) : i.DisplayName) }}
        </a>
      }
    </article>
  </div>
</div>